var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafeform = function SvgSafeform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M15.5 7C14.1 7 13 5.9 13 4.5V1c0-.6-.4-1-1-1H4C1.8 0 0 1.8 0 4v14c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4V8c0-.6-.4-1-1-1zM12 16H6c-.6 0-1-.4-1-1s.4-1 1-1h6c.6 0 1 .4 1 1s-.4 1-1 1m2-4H6c-.6 0-1-.4-1-1s.4-1 1-1h8c.6 0 1 .4 1 1s-.4 1-1 1"
  })));
};
export default SvgSafeform;